import CachedIcon from "@mui/icons-material/Cached";
import { Box, Typography } from "@mui/material";
import { UploadThumbnail } from "@platformx/shared/static-assets";
import { readBrightcoveConfig } from "@platformx/authoring-apis";
import { ErrorTooltip, useAccess } from "@platformx/utilities";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { Category, ContentAction, ContentType } from "../../../../../enums/ContentType";
import { BrightcoveVideoPlayer } from "./BrightcoveVideoPlayer";
import { useStyles } from "./ChooseVideoTray.styles";
import { ChooseVideoTrayProps } from "./ChooseVideoTray.types";

export const ChooseVideoTray: FC<ChooseVideoTrayProps> = ({
  ifVideoUrl,
  onUploadClick,
  brightcoveVideoId,
  poster,
}) => {
  const { t } = useTranslation();
  const { canAccessAction } = useAccess();
  const classes = useStyles();
  const [playbackFailed, setPlaybackFailed] = useState(false);
  const brightcoveConfig = brightcoveVideoId ? readBrightcoveConfig() : undefined;
  const useBrightcove = !!brightcoveVideoId && !!brightcoveConfig?.accountId && !playbackFailed;
  return (
    <ErrorTooltip
      component={
        <Box
          className={
            !canAccessAction(Category.Content, ContentType.Vod, ContentAction.View) ? "disable" : ""
          }>
          {ifVideoUrl ? (
            <Box
              sx={{
                position: "relative",
                borderRadius: "15px",
                overflow: "hidden",
                width: "100%",
                aspectRatio: "16 / 9",
                backgroundColor: "#000",
              }}
              mb={1}>
              {useBrightcove ? (
                <Box
                  sx={{
                    width: "100%",
                    height: "100%",
                    "& .video-js, & .brightcove-player": {
                      width: "100%",
                      height: "100%",
                      paddingTop: "0 !important",
                    },
                  }}>
                  <BrightcoveVideoPlayer
                    accountId={brightcoveConfig?.accountId as string}
                    playerId={brightcoveConfig?.playerId || "default"}
                    videoId={brightcoveVideoId as string}
                    poster={poster}
                    onFailure={() => setPlaybackFailed(true)}
                  />
                </Box>
              ) : (
                <video
                  style={{ width: "100%", height: "100%", objectFit: "contain", display: "block" }}
                  src={ifVideoUrl}
                  poster={poster}
                  controls>
                  <track kind='captions' src='' srcLang='en' label='English captions' default />
                </video>
              )}
              <Box className={classes.replaceTray}>
                <Box onClick={() => onUploadClick("Videos")} data-testid='vod-upload-video'>
                  <Box className={classes.cashedContainer}>
                    <CachedIcon sx={{ color: "#626060" }} />
                  </Box>
                  <Typography mt={1} variant='h7regular' className={classes.whiteColor}>
                    {t("replace")}
                  </Typography>
                </Box>
              </Box>
            </Box>
          ) : (
            <Box
              className={classes.chooseTray}
              onClick={() => onUploadClick("Videos")}
              data-testid='vod-upload-video-1'>
              <Box className={classes.arrowUpContainer} mr={1}>
                <img src={UploadThumbnail} alt='UploadThumbnail' />
              </Box>
              <Box className={classes.chooseTextContainer}>
                <Typography variant='h5medium'>{t("video_subtitle")}</Typography>
              </Box>
            </Box>
          )}
        </Box>
      }
      doAccess={!canAccessAction(Category.Content, ContentType.Vod, ContentAction.View)}
    />
  );
};
